<template>
  <v-container class="pt-0">
    <v-layout column>
      <v-flex>
        <div class="dropbox" v-if="isInitial || isSaving">
          <input
            @change="processImage"
            type="file"
            name="photo"
            accept="image/*"
            :disabled="isSaving"
            class="input-file"
          />
          <p v-if="isInitial">
            <strong>Upload a new image</strong>
            <span v-if="optimalSize"><br />{{ optimalSize }}</span>
            <br />Drag your file here to begin<br />
            or click to browse
          </p>
          <p v-if="isSaving">
            Uploading files...
          </p>
        </div>
        <!--SUCCESS-->
        <div v-if="isSuccess">
          <h3>Uploaded file successfully.<br />Click 'Update' to save changes</h3>
          <p>
            <a href="javascript:void(0)" @click="reset()">Upload again</a>
          </p>
        </div>
        <!--FAILED-->
        <div v-if="isFailed">
          <h3>Uploaded failed.</h3>
          <p>
            <a href="javascript:void(0)" @click="reset()">Try again</a>
          </p>
          <pre>{{ uploadError }}</pre>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import image from '../../../api/images';

const STATUS_INITIAL = 0;
const STATUS_SAVING = 1;
const STATUS_SUCCESS = 2;
const STATUS_FAILED = 3;

export default {
  name: 'image-edit-upload',
  props: ['path', 'url', 'optimalSize'],
  data() {
    return {
      uploadError: null,
      currentStatus: null
    };
  },
  computed: {
    isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED;
    }
  },
  methods: {
    reset() {
      this.currentStatus = STATUS_INITIAL;
      this.uploadError = null;
    },
    processImage: function(element) {
      const files = element.target.files;
      if (!files[0]) {
        return;
      }

      image
        .upload(files, this.path)
        .then(response => {
          this.$emit('update:url', response.url);
          this.currentStatus = STATUS_SUCCESS;
        })
        .catch(err => {
          this.uploadError = err.response;
          this.currentStatus = STATUS_FAILED;
        });
    }
  },
  mounted() {
    this.reset();
  }
};
</script>

<style scoped>
.dropbox {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  background: lightcyan;
  color: dimgray;
  padding: 10px 10px;
  min-height: 160px; /* minimum height */
  position: relative;
  cursor: pointer;
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 160px;
  position: absolute;
  cursor: pointer;
}

.dropbox:hover {
  background: lightblue; /* when mouse over to the drop zone, change color */
}

.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 30px 0;
}
</style>
